const tr = {
  pendingFiles: {
    attributes: {
      user_id: 'ID',
      name: 'Nome do paciente',
      created_at: 'Criado em',
    },
    defSingular: 'Documento pendente',
    defPlural: 'Documentos pendentes',
  },
};

export default tr;
